import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n';
import actionTypes from '../../constants/actions/perfil/perfil'
import { cerrarModalPerfil, fetchPerfilSuccess, cerrarCambiarPassPerfil, cambiarPasswordPerfilSuccess } from '../../actions/perfil/perfil'
import { submitNuevoUsuarioSuccess} from '../../actions/usuarios/usuarios'
import {cambiarImagenAuth, cambiarNombreUsuarioAuth} from '../../actions/auth/auth'
import {openSimpleModal, openMensajeAlerta, closeMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import {yesNoModal as yesNoModalSaga} from '../modal/yesNoModal'
import editPerfil from '../../services/perfil/editPerfil'
import getPerfil from '../../services/perfil/getPerfil'
import updatePassword from '../../services/perfil/updatePassword'

export function * fetchPerfil () {
  try {
    let state = yield select(state => state)
    const dataPerfil = yield call(getPerfil, null)
    if (dataPerfil.idioma === 'es'){
      dataPerfil.idioma = {value: 'es', label: i18n.t('COMUN.COMBOS.IDIOMA.ESPANOL')}
    }
    else if (dataPerfil.idioma === 'en') {
      dataPerfil.idioma = {value: 'en', label: i18n.t('COMUN.COMBOS.IDIOMA.INGLES')}
    }
    else if (dataPerfil.idioma === 'ch') {
      dataPerfil.idioma = {value: 'ch', label: i18n.t('COMUN.COMBOS.IDIOMA.CHINO')}
    }
    else if (dataPerfil.idioma === 'ru') {
      dataPerfil.idioma = {value: 'ru', label: i18n.t('COMUN.COMBOS.IDIOMA.RUSO')}
    }
    else if (dataPerfil.idioma === 'ja') {
      dataPerfil.idioma = {value: 'ja', label: i18n.t('COMUN.COMBOS.IDIOMA.JAPONES')}
    }
    else if (dataPerfil.idioma === 'ko') {
      dataPerfil.idioma = {value: 'ko', label: i18n.t('COMUN.COMBOS.IDIOMA.COREANO')}
    }
    dataPerfil.formaFechaHora = {value: dataPerfil.formaFechaHora, label: dataPerfil.formaFechaHora}
    dataPerfil.separadorDec = {value: dataPerfil.separadorDec, label: dataPerfil.separadorDec}
    dataPerfil.separadorMil = {value: dataPerfil.separadorMil, label: dataPerfil.separadorMil}
    let fotmatFecHor = dataPerfil.formaFechaHora.value.split('/')
    dataPerfil.formaFecha = {value: fotmatFecHor[0] + '/' + fotmatFecHor[1] + '/' + fotmatFecHor[2], label: fotmatFecHor[0] + '/' + fotmatFecHor[1] + '/' + fotmatFecHor[2]}
    dataPerfil.formaHora = {value: '/' + fotmatFecHor[3], label: fotmatFecHor[3] + 'h'}
    dataPerfil.zonaHoraria = dataPerfil.zonaHoraria !== null && {value: dataPerfil.zonaHoraria, label: dataPerfil.zonaHoraria}
    yield put(initialize('ModalPerfil', dataPerfil))
    yield put (fetchPerfilSuccess(dataPerfil))
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchFetchPerfil () {
  yield takeLatest(actionTypes.FETCH_PERFIL, fetchPerfil)
}

export function * editarPerfil ({values}) {
  try {
    let state = yield select(state => state)
    let auth = yield select(state => state.auth)
    const edicionPerfil = yield call(editPerfil, values, auth.token)
    if (edicionPerfil.actualizado === true && edicionPerfil.existeUsuario === false) {
      // ACTUALIZAR MODAL CON LOS CAMBIOS
      const dataPerfil = yield call(getPerfil, null)
      if (dataPerfil.idioma === 'es'){
        dataPerfil.idioma = {value: 'es', label: i18n.t('COMUN.COMBOS.IDIOMA.ESPANOL')}
      }
      else if (dataPerfil.idioma === 'en') {
        dataPerfil.idioma = {value: 'en', label: i18n.t('COMUN.COMBOS.IDIOMA.INGLES')}
      }
      else if (dataPerfil.idioma === 'ch') {
        dataPerfil.idioma = {value: 'ch', label: i18n.t('COMUN.COMBOS.IDIOMA.CHINO')}
      }
      else if (dataPerfil.idioma === 'ru') {
        dataPerfil.idioma = {value: 'ru', label: i18n.t('COMUN.COMBOS.IDIOMA.RUSO')}
      }
      else if (dataPerfil.idioma === 'ja') {
        dataPerfil.idioma = {value: 'ja', label: i18n.t('COMUN.COMBOS.IDIOMA.JAPONES')}
      }
      else if (dataPerfil.idioma === 'ko') {
        dataPerfil.idioma = {value: 'ko', label: i18n.t('COMUN.COMBOS.IDIOMA.COREANO')}
      }
      dataPerfil.formaFechaHora = {value: dataPerfil.formaFechaHora, label: dataPerfil.formaFechaHora}
      let fotmatFecHor = dataPerfil.formaFechaHora.value.split('/')
      dataPerfil.formaFecha = {value: fotmatFecHor[0] + '/' + fotmatFecHor[1] + '/' + fotmatFecHor[2], label: fotmatFecHor[0] + '/' + fotmatFecHor[1] + '/' + fotmatFecHor[2]}
      dataPerfil.formaHora = {value: '/' + fotmatFecHor[3], label: fotmatFecHor[3] + 'h'}
      dataPerfil.separadorDec = {value: dataPerfil.separadorDec, label: dataPerfil.separadorDec}
      dataPerfil.separadorMil = {value: dataPerfil.separadorMil, label: dataPerfil.separadorMil}
      yield put(initialize('ModalPerfil', dataPerfil))
      yield put (fetchPerfilSuccess(dataPerfil))
      // AÑADIR IMAGEN AL AUTH
      if (values.idUsuario === auth.idUsuario) {
        yield put(cambiarImagenAuth(values.imagenUsuario !== null ? values.imagenUsuario.file.imagebase64 : null))
        yield put(cambiarNombreUsuarioAuth(values.nombreUsuario))
      }
      yield put(cerrarModalPerfil())
      yield put(openMensajeAlerta('modificacion'))
      yield put(submitNuevoUsuarioSuccess(edicionPerfil))
    } else {
      yield put(openMensajeAlerta('no-modificacion'))
      yield put(cerrarModalPerfil())
      yield put(submitNuevoUsuarioSuccess(edicionPerfil))
    }
  } catch (error) {}
}
export function * watchEditarPerfil () {
  yield takeLatest(actionTypes.EDITAR_PERFIL, editarPerfil)
}

export function * cambiarPasswordPerfil ({values}) {
  try {
    let auth = yield select(state => state.auth)
    const edicionPass = yield call(updatePassword, values, auth.token)
    if (edicionPass.actualizado === true) {
      yield put(openMensajeAlerta('modificacion'))
      yield put(cerrarCambiarPassPerfil())
      yield put(cambiarPasswordPerfilSuccess(edicionPass.actualizado))
    } else {
      // yield put(openMensajeAlerta('no-modificacion'))
      yield put(cambiarPasswordPerfilSuccess(edicionPass.actualizado))
    }
    yield put(initialize('ModalCambiarPassPerfil', ''))
  } catch (error) {}
}
export function * watchCambiarPasswordPerfil () {
  yield takeLatest(actionTypes.CAMBIAR_PASSWORD_PERFIL, cambiarPasswordPerfil)
}
